<section
    *ngIf="value"
    [ngClass]="{
        'agpr-monitoringKeywords ui-widget u-mdPadding': true,
        styleClass: true
    }"
>
    <div
        class="agpr-monitoringKeywords-chipsContainer"
        role="group"
        [attr.aria-labelledby]="id + '_label'"
        [attr.aria-describedby]="ariaDescribedBy"
    >
        <div class="agpr-monitoringKeywords-chipRow">
            <agpr-text-input-chips
                [id]="id + '_or'"
                class="agpr-monitoringKeywords-chipRow-input"
                [header]="isImageSearch ? 'Monitoring.keyWords.orImageDescription' : 'Monitoring.keyWords.orWordsDescription'"
                placeholder="Monitoring.search.enterKeywordsOrPhrases"
                [chipValidations]="value.keywordValidations"
                [splitOnPattern]="splitOnPattern"
                [trimQuotes]="true"
                [ariaLabelledBy]="id + '_orLabel'"
                [(ngModel)]="value.or"
                (ngModelChange)="onModelChange(value)"
            ></agpr-text-input-chips>
        </div>
        <div class="agpr-monitoringKeywords-chipRow">
            <agpr-text-input-chips
                [id]="id + '_and'"
                class="agpr-monitoringKeywords-chipRow-input"
                [chipValidations]="value.keywordValidations"
                [header]="isImageSearch ? 'Monitoring.keyWords.andImageDescription' : 'Monitoring.keyWords.andWordsDescription'"
                placeholder="Monitoring.search.enterKeywordsOrPhrases"
                [splitOnPattern]="splitOnPattern"
                [ariaLabelledBy]="id + '_andLabel'"
                [trimQuotes]="true"
                [(ngModel)]="value.and"
                (ngModelChange)="onModelChange(value)"
            ></agpr-text-input-chips>
        </div>
        <div class="agpr-monitoringKeywords-chipRow">
            <agpr-text-input-chips
                [id]="id + '.excludeChips'"
                class="agpr-monitoringKeywords-chipRow-input"
                [header]="isImageSearch ? 'Monitoring.keyWords.notImageDescription' : 'Monitoring.keyWords.notWordsDescription'"
                placeholder="Monitoring.search.enterKeywordsOrPhrases"
                [chipValidations]="value.keywordValidations"
                [splitOnPattern]="splitOnPattern"
                [trimQuotes]="true"
                [ariaLabelledBy]="id + '_notLabel'"
                [(ngModel)]="value.not"
                (ngModelChange)="onModelChange(value)"
            ></agpr-text-input-chips>
        </div>
    </div>
</section>
